import React from "react";
import PropTypes from "prop-types";
import VuiBox from "components/VuiBox";

const YoutubeEmbed = ({ embedId }) => (
  <VuiBox className="video-responsive">
    <iframe
      src={`https://www.youtube.com/embed/${embedId}`}
      title="YouTube video player"
      frameBorder="5s"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </VuiBox>
);

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
};

export default YoutubeEmbed;
